  <div class="sx-guide sx-guide__dialog">
    <app-guide-viewer [pages]="pages" (cancel)="onCancel()"></app-guide-viewer>
  </div>
